module.exports = __webpack_public_path__ + "static/img/img_parameter@2x.662b110f.png";